export const CODIGO_LISTA_DOCUMENTACION =
  "jUE8ZM00udOApGk5yafb1UJ7Ap9t1dBWietr1Y0782jKx672sC4YTQ==";
export const CODIGO_BUSCAR_USER =
  "57Mzph9Z1aXzvCreVqOzOkkBBeANGBliy754nthjcBDq6IvSJqdCmg==";
export const CODIGO_MODIFICAR_DOCUMENTO =
  "8U/OO8o9aznO4ZKABawQXipu2w9ttf1ydZ8yVad3bLmyES48GNyvhg==";
